var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');
// require('bootstrap/js/dist/util');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

require('jquery.placeholder');
require('jquery-sticky');
// require('jquery-match-height');
require('@fortawesome/fontawesome-free');

require('owl.carousel');
require('owl.carousel2.thumbs');
require('magnific-popup');
require('lazysizes');
// require('picturefill');
lazySizes.init();

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

window.initProductSlider = (sliderEl, thumbnailEl) => {

    var slider = $(sliderEl);
    // reference for thumbnail items
    var thumbnailSlider = $(thumbnailEl);
    //transition time in ms
    var duration = 500;

    // carousel function for main slider
    slider.owlCarousel({
        loop: false,
        nav: false,
        dots: false,
        smartSpeed: 750,
        items: 1,

    }).on('changed.owl.carousel', function(e) {
        //On change of main item to trigger thumbnail item
        thumbnailSlider.trigger('to.owl.carousel', [e.item.index, duration, true]);
    });

    // carousel function for thumbnail slider
    thumbnailSlider.owlCarousel({
        loop: false,
        center: false, //to display the thumbnail item in center
        nav: true,
        dots: false,
        smartSpeed: 750,
        margin: 0,
        items: 6,
        navText: [
            "<i class='material-icons'>keyboard_arrow_left</i>", "<i class='material-icons'>keyboard_arrow_right</i>"
        ]


    }).on('click', '.owl-item', function() {
        // On click of thumbnail items to trigger same main item
        slider.trigger('to.owl.carousel', [$(this).index(), duration, true]);

    }).on('changed.owl.carousel', function(e) {
        // On change of thumbnail item to trigger main item
        slider.trigger('to.owl.carousel', [e.item.index, duration, true]);
    });

}

$(function() {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $('.selectpicker').selectpicker();

    $('#login-modal').on('shown.bs.modal', function() {
        $('#email-login-modal').trigger('focus')
    })

    if ($('#customer-checkout-modal').length) {
        $('#customer-checkout-modal').modal('show');
    }

    // placeholder polyfill for browsers that need it
    $('input, textarea').placeholder();

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('btn-close')
        $(".top-nav").toggleClass('fixed-top')
    });

    // $('.learn-more').on('click',function(e){
    //     e.preventDefault();
    //     document.querySelector('.learn-more-content').scrollIntoView({
    //         behavior: 'smooth'
    //     });
    // });


    //learn more scroll
    $(window).on('resize load', function() {
        if ($(window).width() < 768) {

            $('.learn-more').bind('click', function(event) {
                var $anchor = $(this);

                $('html, body').stop().animate({
                    scrollTop: $($anchor.attr('href')).offset().top - 160
                }, 750, 'easeInOutExpo');

                event.preventDefault();
            });

        } else {

            $('.learn-more').bind('click', function(event) {
                var $anchor = $(this);

                $('html, body').stop().animate({
                    scrollTop: $($anchor.attr('href')).offset().top - 70
                }, 750, 'easeInOutExpo');

                event.preventDefault();
            });


        }

    });



    $("#sticky-news-btn").sticky({ topSpacing: 74 });
    $("#sticky-news-share").sticky({ topSpacing: 74 });


    if ($('#form-customer-register').length) {
        $('#apply_account').change(function() {
            // this will contain a reference to the checkbox
            if (this.checked) {
                // the checkbox is now checked
                $('#company').attr('required', true);
                $('#role').attr('required', true);
            } else {
                // the checkbox is now no longer checked
                $('#company').removeAttr('required');
                $('#role').removeAttr('required');
            }
        });
    }

    $(window).on('load resize', function(e) {
        var window_width = $(window).width();

        if (window_width >= 992) {
            // $('html, body').removeClass('overflow-x');
            if(e.type == 'load'){
                make_desktop_sticky_header();
            }
            // $("#sticky-wrapper").css("height", 83)

        } else {
            // $('html, body').addClass('overflow-x');
            if(e.type == 'load'){
                make_mobile_sticky_header();
            }
            // $("#sticky-wrapper").css("height", 48)
        }

    });

    /*if ($('#main-slider').length) {
        $('#main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            // animateIn: 'fadeIn', // add this
            // animateOut: 'fadeOut'
        })
    }*/

    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            mouseDrag:false,
            // animateIn: 'fadeIn', // add this
            // animateOut: 'fadeOut'
        })
    }

    if ($('.promo-items').length) {
        $('.promo-items').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            margin: 0,
            responsiveClass: true,
            items: 2,
            nav: false,
            dot: true,
            autoplay: false,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 2
                },

                576: {
                    items: 2
                },

                768: {
                    items: 3
                },

                992: {
                    items: 4,
                    nav: true,
                    dots: false
                },

                1200: {
                    items: 5,
                    nav: true,
                    dots: false
                }
            }

        })
    }

    if ($('.recommended-carousel').length) {
        $('.recommended-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 2,
            nav: false,
            dot: true,
            autoplay: false,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 1
                },

                576: {
                    items: 2
                },

                768: {
                    items: 3
                },

                992: {
                    items: 4,
                    nav: true,
                    dots: false
                }
            }

        })
    }

    // if ($('#products-slider').length) {
        // window.initProductSlider('#products-slider', '#thumbnailSlider');

        // Product Images popup
        // $('.popup-image').magnificPopup({
        //     type: 'image',
        //     gallery: {
        //         enabled: true
        //     },
        //     disableOn: function() {
        //         if ($(window).width() < 600) {
        //             return false;
        //         }
        //         return true;
        //     }
        // });
    // }

    // $('.scrollup').click(function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });


    // $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    //     disableOn: 700,
    //     type: 'iframe',
    //     mainClass: 'mfp-fade',
    //     removalDelay: 160,
    //     preloader: false,
    //     fixedContentPos: false,
    //     gallery: {
    //         enabled: true
    //     },
    // });

    $('.announcement').each(function() {
        var $announcement = $(this);
        var announcementKey = 'announcement' + $announcement.data('id');

        if (!window.sessionStorage.getItem(announcementKey)) {
            $announcement.removeClass('d-none');
            $announcement.addClass('d-flex');
        }

        $announcement.find('button,a').on('click', function() {
            window.sessionStorage.setItem(announcementKey, 1);
        })
    })

    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    // add custom hover toggle for nav links
    $('[data-toggle-hover]').hover(function() {
        var $this = $(this);
        var targetClass = $this.data('toggle-hover');
        var $target = $this.closest('.' + targetClass).find('.' + targetClass + '-menu');
        $target.addClass('show');
        $target.parent().off('mouseleave').on('mouseleave', function() {
            $target.removeClass('show');
        })
    })

    //dropdown inside dropdown
    $('.dropdown.dropdown-keep-open').on({
        'mouseleave': function() {
            this.closable = true;
        },
        'mouseenter': function() {
            this.closable = false;
        },
        'hide.bs.dropdown': function(e) {
            if ($(e.target).hasClass('dropdown-keep-open')) {
                return this.closable;
            }

            return true;
        },
    })

    $('.btn-cart').each(function() {
        var $this = $(this);
        var productId = $this.data('id');
        if (!productId) return;

        $this.on('click', function() {
            var event = new CustomEvent('product::updated', {
                detail: { product_id: productId },
            });
            document.dispatchEvent(event);
        })
    });

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'fas fa-arrow-up',
            down: 'fas fa-arrow-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'far fa-calendar-check',
            clear: 'far fa-calendar-times',
            close: 'far fa-times-circle'
        }
    });
    $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false //Important! See issue #1075
    });

    $('.datepicker-start').on("dp.change", function(e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });
    $('.datepicker-end').on("dp.change", function(e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });

    $('.reset-filter').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').find('input[type=text]').val('');
    });
});

function make_desktop_sticky_header() {

    $(".top-nav").unstick({});
    $("#sticky-search").sticky({
        topSpacing: 0,
        zIndex: 1000,
        update: true
    });

}

function make_mobile_sticky_header() {
    $(".top-nav").sticky({
        topSpacing: 0,
        zIndex: 1050
    });
    $("#sticky-search").sticky({
        topSpacing: 48,
        zIndex: 1000
    });
}

window.dispatchEvent(new CustomEvent('init'));

window.trackingEvent = function trackingEvent(eventName, data) {
    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js